export const ONLY_NUMBER_REGEX = /^[-.eE]$/;
export const DIFF_NUMBER_DOT_COMMA_REGEX = /^[-eE]$/;
export const COORDINATE_REGEX =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?((\d|[1-9]\d{0,2})(\.\d+)?|180(\.0+)?)/;
export const NUMBER_WITH_COMMA_REGEX = /^[0-9,]+(\.[0-9]*)?$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const NUMBER_REGEX = /^(?=.*[0-9]).*$/;
export const LOWERCASE_AND_UPPERCASE_REGEX = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
export const SYMBOL_REGEX = /^(?=.*[\W_]).*$/;
export const STRONG_PASSWORD_REGEX =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])(?=.{8,}).*$/;
export const ONLY_NUMERIC_REGEX = /[^0-9]/g;
export const ONLY_NUMERIC_REGEX_TRIM_PREFIX_ZERO = /[^0-9]|^0+/g;
export const COORDINATE_POTENTIAL_REGEX =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0*)?)(,\s*([-+]?(\d{1,3}(\.\d+)?|180(\.0*)?)?)?)?$/;

/**
 *
 * Creates a regex that matches strings with minimum length
 * @param length Minimum length required
 * @returns RegExp that validates minimum length
 */
export const createMinLengthRegex = (length: number): RegExp => {
  return new RegExp(`^.{${length},}$`);
};

// DAY.js FORMAT DATE
export const TIME_REGEX = /HH:MM/g;
export const SECOND_REGEX = /:SS/g;
export const AMPM_REGEX = /AM\/PM/g;
export const DAY_REGEX = /DD/g;
export const MONTH_REGEX = /Month/g;
export const YEAR_REGEX = /YYYY/g;
